import React, { useState } from "react";
import Header from "../../../commons/header/header";
import Footer from "../../../commons/footer/footer";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
} from "@mui/material";
import "../committee.css"; // Import the CSS file

const GRC = () => {
  const [selectedTab, setSelectedTab] = useState("committee");

  const rows = [
    {
      id: 1,
      name: "Dr. Eswaramoorthi P",
      designation: "Principal",
      mobile: "7708069402",
      email: "acetcoimbatore@gmail.com",
      address: "5, 6 Perumal Kovil Street, Saravanampatti, Coimbatore- 641 035",
    },
    {
      id: 2,
      name: "Dr. Vijaya Baskar",
      designation: "Assistant Professor",
      mobile: "7010881629",
      email: "vb@aurcc.ac.in",
      address: "Anna University Regional campus, Coimbatore 641046",
    },
    {
      id: 3,
      name: "Mr.Govindharajan V",
      designation: "President / Kondayampalayam",
      mobile: "9994508888",
      email: "govindrevarthi@gmail.com",
      address:
        "Villagepanchayat office, Kondayampalayam, Vaiyampalayam(po), Coimbatore-641104",
    },
    {
      id: 4,
      name: "Dr. Nancy Priya",
      designation: "HOD/AGRI",
      mobile: "6380729210",
      email: "Snancypriya88@gmail.com",
      address: "119, Green fields crown city, SS Kulam, Coimbatore641110",
    },
    {
      id: 5,
      name: "Mr. Durairaj N",
      designation: "Assistant Professor",
      mobile: "8903536371",
      email: "durairajnagaraj@gmail.com",
      address: "59 / 1 School street, Edayarpalayam, Coimbatore- 641 025",
    },
    {
      id: 6,
      name: "Mr.Faizal Rahman S",
      designation: "Assistant Professor",
      mobile: "8012060120",
      email: "mailtosfr@gmail.com",
      address: "3, Ponvizha Nagar, South Ukkadam, Coimbatore-641001",
    },
    {
      id: 7,
      name: "Mrs.Nandhini",
      designation: "Assistant Professor",
      mobile: "9962260469",
      email: "acetnandhini@gmail.com",
      address: "132, Breeze Garden, Athipalayam, Coimbatore-641110",
    },
    {
      id: 8,
      name: "Miss. Priyadharshini A",
      designation: "Student (II IT)",
      mobile: "9344673973",
      email: "Piyaayyappan2006@gmail.com",
      address: "West Street, Andarpandhi, Kudavasal, Thiruvarur.612601",
    },
    {
      id: 9,
      name: "Mr.Maharaja Prabhu N P",
      designation: "Student (III CSE)",
      mobile: "6380856382",
      email: "prabhumaharaja2@gmail.com",
      address: "4/249, SS Colony, Udumalpet, Tirupur.642126",
    },
  ];

  const handlePDFClick = () => {
    window.open(
      `${process.env.PUBLIC_URL}/pdf/grc_minutes_of_meeting.pdf`,
      "_blank"
    );
  };
  return (
    <>
      <Header />
      <div className="antiragging-container">
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          width="100%"
        >
          {/* Left side menu */}
          <Box
            flex={{ xs: "none", sm: "0 0 200px" }}
            bgcolor="transparent"
            p={2}
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            gap={1} // Add spacing between buttons
            sx={{
              // Responsive styling
              "@media (max-width: 600px)": {
                flex: "0 0 auto",
              },
              "@media (min-width: 600px)": {
                flex: "0 0 200px",
              },
            }}
          >
            <Button
              variant={selectedTab === "committee" ? "contained" : "outlined"}
              onClick={() => setSelectedTab("committee")}
              style={{
                width: "100%",
                color: selectedTab === "committee" ? "#FFF" : "#000",
                borderColor:
                  selectedTab === "committee" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Grievance Redressal Committee
            </Button>
            <Button
              variant={selectedTab === "mom" ? "contained" : "outlined"}
              onClick={handlePDFClick}
              style={{
                width: "100%",
                color: selectedTab === "mom" ? "#FFF" : "#000",
                borderColor: selectedTab === "mom" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Minutes Of Meeting
            </Button>
          </Box>

          {/* Right side content */}
          <Box flex="1" p={2}>
            <h2>
              {selectedTab === "committee"
                ? "Grievance Redressal Committee"
                : "mom"}
            </h2>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      S.No.
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Name of the Members
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Designation
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Category
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Email
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Address
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(selectedTab === "committee"
                    ? rows
                    : selectedTab === "mom"
                  ).map((row, index) => (
                    <TableRow
                      key={row.id}
                      style={{
                        backgroundColor: index % 2 === 0 ? "white" : "#f1f8e9",
                      }}
                    >
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.designation}</TableCell>
                      <TableCell>{row.mobile}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{row.address}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </div>
      <Footer />
    </>
  );
};

export default GRC;
